export const atMentionRegex = /(@[0-9A-Za-z@\\.]+)/;
